module.exports = __webpack_public_path__ + "img/destination_udzungwa_ln.80340fbe.jpg";